var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketenergy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 44,
    rx: 8.5,
    fill: "#073242",
    stroke: "#034A65"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1989 11L30.9996 12.734L20.7277 22.2482L32.5624 21.5939L12.639 38.8019L21.9634 26.3214L12 26.9723L21.1989 11Z",
    fill: "#2E3192"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4596 11.5776L12.9336 26.3871L23.0563 25.721L15.9338 35.2572L31.0501 22.2038L19.3001 22.8496L29.8584 13.0642L21.4596 11.5776Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0724 33.4045L31.0394 22.2071L19.2895 22.8529L29.8478 13.0675L22.2219 11.7183L14.0586 25.8904L24.183 25.2243L18.0724 33.4045Z",
    fill: "#9DDCF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6433 22.3343L19.3087 22.8479L29.8671 13.0625L27.9991 12.7319C25.6007 13.015 22.3937 14.7422 19.5037 17.5204C18.946 18.056 18.4273 18.6069 17.9493 19.1629L14.5321 25.0955C14.4626 25.3599 14.4084 25.6159 14.3711 25.865L24.2006 25.2192L22.0936 28.0398C23.5327 27.2278 25.0277 26.1159 26.4465 24.7531C27.2669 23.9666 28.0009 23.153 28.6433 22.3343Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketenergy);
export default __webpack_public_path__ + "static/media/marketenergy.bcc55b8f5630d7457db0575ffb0ea816.svg";
export { ForwardRef as ReactComponent };